import { useRef, useEffect, useState } from "react";
import { motion, useInView } from "framer-motion";

const STATS = [
  { value: 2022, prefix: "EST. ", label: "Houston, Texas", plain: true },
  { value: 48, suffix: "", label: "Lower 48 states covered" },
  { value: 100, suffix: "%", label: "Owner-operated accountability" },
  { value: 24, suffix: "/7", label: "Dispatch communication" },
];

function Counter({ value, prefix = "", suffix = "", plain }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    if (plain) {
      setN(value);
      return;
    }
    let raf;
    const start = performance.now();
    const dur = 1400;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, plain]);

  return (
    <span ref={ref} className="font-display text-6xl font-black tracking-tighter md:text-8xl">
      {prefix}
      {n}
      {suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section data-testid="stats" className="mx-auto max-w-[1600px] px-5 py-24 md:px-10 md:py-32">
      <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="flex flex-col gap-3 bg-ink p-8 md:p-10"
          >
            <Counter value={s.value} prefix={s.prefix} suffix={s.suffix} plain={s.plain} />
            <span className="text-sm uppercase tracking-widest text-[#a1a1a8]">{s.label}</span>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
